import { render, staticRenderFns } from "./report-found-other.vue?vue&type=template&id=c4824386"
import script from "./report-found-other.vue?vue&type=script&lang=js"
export * from "./report-found-other.vue?vue&type=script&lang=js"
import style0 from "./report-found-other.vue?vue&type=style&index=0&id=c4824386&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports